export default "__VITE_ASSET__C5L7YPqM__"